import React, { Suspense, useEffect } from 'react';

import { useElementSize } from 'client-web-sdk';

import styles from './Confetti.module.css';

const ReactConfetti = React.lazy(() => import('react-confetti'));

export default function Confetti({
  showConfetti,
  setShowConfetti,
}: {
  showConfetti: boolean;
  setShowConfetti: (s: boolean) => void;
}) {
  const [setSizeElement, size] = useElementSize<HTMLElement>();
  useEffect(() => {
    setSizeElement(document.getElementById('root'));
  }, [setSizeElement]);

  return (
    <Suspense fallback={null}>
      {showConfetti && (
        <ReactConfetti
          className={styles.Confetti}
          numberOfPieces={showConfetti ? 500 : 0}
          recycle={false}
          onConfettiComplete={(confetti) => {
            setShowConfetti(false);
            confetti?.reset();
          }}
          {...size}
        />
      )}
    </Suspense>
  );
}
